import React from "react";
import {TableLink} from "peggirkit";
import {FormattedMessage} from "react-intl";
import {SetStateFn} from "@/utils/SetStateUtils";
import {EditDeliveryAreaState} from "@widgets/deliveryAreas/edit/EditDeliveryAreaModal";
import {DeliveryArea} from "@/data/entities/deliveryArea";

type Props = {
    editDeliveryAreaState: SetStateFn<EditDeliveryAreaState>,
    deliveryArea: DeliveryArea,
};

const EditButton = ({deliveryArea, editDeliveryAreaState}: Props) => {
    return (
        <TableLink
            buttonAction={{
                as: "button",
                actionProps: {
                    onClick: e => {
                        e.preventDefault();
                        editDeliveryAreaState({showModal: true, deliveryArea});
                    }
                },
            }}
        >
            <FormattedMessage id={"edit"}/>
        </TableLink>
    );
};

export default EditButton;